(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[722],{

/***/ 3010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Divider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _divider_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1520);
/* harmony import */ var _divider_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_divider_module_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);



var Divider = function(param) {
    var margin = param.margin;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_divider_module_css__WEBPACK_IMPORTED_MODULE_2___default().divider),
        style: {
            margin: margin
        }
    });
};



/***/ }),

/***/ 9057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Divider_Divider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3010);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_InitialParams__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2172);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _locales_en__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7428);
/* harmony import */ var _locales_ru__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7387);









var Footer = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var t = router.locale === "en" ? _locales_en__WEBPACK_IMPORTED_MODULE_7__.en : _locales_ru__WEBPACK_IMPORTED_MODULE_8__.ru;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("footer", {
        className: "footer container",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "nav-side",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "footer-nav",
                            children: _utils_InitialParams__WEBPACK_IMPORTED_MODULE_5__/* .footerList.map */ .WW.map(function(item, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        href: item.url,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            className: "nav__link",
                                            dangerouslySetInnerHTML: {
                                                __html: item.nameUrl
                                            }
                                        })
                                    })
                                }, index);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Divider_Divider__WEBPACK_IMPORTED_MODULE_3__/* .Divider */ .i, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "nav__link company-name",
                        children: [
                            new Date().getFullYear(),
                            " @ Face2"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "contacts-block",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "contacts",
                        children: t.footer.contacts
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "contacts__email-list",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "body-text contact-icon-text",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "contacts__icon-container",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        height: 24,
                                        width: 24,
                                        src: "/message-icon.svg",
                                        alt: "message icon"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        rel: "nofollow",
                                        href: "mailto:support@face2.ru",
                                        children: "support@face2.ru"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "nav__link company-name",
                        children: [
                            new Date().getFullYear(),
                            " @ Face2"
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Footer);


/***/ }),

/***/ 1506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Header; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroup.js + 2 modules
var TransitionGroup = __webpack_require__(844);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js + 3 modules
var CSSTransition = __webpack_require__(6743);
// EXTERNAL MODULE: ./helpers.ts
var helpers = __webpack_require__(1857);
// EXTERNAL MODULE: ./components/modalLayout/ModalLayout.tsx + 38 modules
var ModalLayout = __webpack_require__(7114);
// EXTERNAL MODULE: ./locales/en.js
var en = __webpack_require__(7428);
// EXTERNAL MODULE: ./locales/ru.js
var ru = __webpack_require__(7387);
;// CONCATENATED MODULE: ./components/Menu/Menu.tsx






var Menu = function(param) {
    var items = param.items, openMenu = param.openMenu;
    var modal = (0,react.useContext)(ModalLayout/* ModalContext */.t);
    var t = window.location.pathname === "/en" ? en.en : ru.ru;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "menu",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "menu__content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: items.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: item.link,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "nav__link",
                                        children: item.title
                                    })
                                })
                            }, item.link);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            width: "100%",
                            maxWidth: "200px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "button_base",
                            onClick: modal.openFormModal,
                            children: t.btn.consultationCost
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "close-bg",
                onClick: function() {
                    openMenu(false);
                }
            })
        ]
    });
};
/* harmony default export */ var Menu_Menu = (Menu);

// EXTERNAL MODULE: ./utils/InitialParams/index.ts
var InitialParams = __webpack_require__(2172);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 2 modules
var Box = __webpack_require__(7417);
;// CONCATENATED MODULE: ./components/Header/Header.tsx















var Pass = function(param) {
    var firstSection = param.firstSection;
    var ref = (0,react.useState)(false), isOpenMenu = ref[0], openMenu = ref[1];
    var header = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var modal = (0,react.useContext)(ModalLayout/* ModalContext */.t);
    var t = router.locale === "en" ? en.en : ru.ru;
    (0,react.useEffect)(function() {
        var sectionEl = firstSection.current;
        var headerEl = header.current;
        var introH = (sectionEl === null || sectionEl === void 0 ? void 0 : sectionEl.offsetTop) + (sectionEl === null || sectionEl === void 0 ? void 0 : sectionEl.offsetHeight);
        (0,helpers/* headerMenuOffsetController */.JJ)(headerEl, introH);
    }, [
        firstSection,
        header,
        isOpenMenu
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Face 2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "face2 face2pay face2security face2action"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.ico"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("header-container", {
                    "bg-white": isOpenMenu
                }),
                ref: header,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                    className: "header container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            className: "header__logoNav",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "logo-text",
                                        children: [
                                            "Face",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "face2-logo-container",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    width: 40,
                                                    height: 40,
                                                    src: "/logo.svg",
                                                    alt: "logo"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                    className: "desktop-header-nav",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "nav-list",
                                        children: InitialParams/* headerNavList.map */.A7.map(function(item, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: item.url,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "nav__link",
                                                        children: item.nameUrl
                                                    })
                                                })
                                            }, index);
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                display: "flex",
                                alignItems: "center",
                                gap: "16px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "header__btnBlock",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "button_base",
                                        onClick: modal.openFormModal,
                                        children: t.btn.consultationCost
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "16px",
                                        cursor: "pointer"
                                    },
                                    onClick: function() {
                                        router.push(router.asPath, router.asPath, {
                                            locale: router.locale === "en" ? "ru" : "en"
                                        });
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: router.locale === "en" ? "/eng_logo.png" : "/ru_logo.png",
                                            height: 18,
                                            width: 24
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "nav__link",
                                            children: router.locale === "en" ? "Eng" : "Rus"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "burger-btn",
                                    onClick: function() {
                                        return openMenu(function(prev) {
                                            return !prev;
                                        });
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TransitionGroup/* default */.Z, {
                            component: null,
                            children: isOpenMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
                                in: isOpenMenu,
                                timeout: 300,
                                classNames: "alert",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_Menu, {
                                    items: InitialParams/* menuList */.sh,
                                    openMenu: openMenu
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Header = (Pass);


/***/ }),

/***/ 1857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JJ": function() { return /* binding */ headerMenuOffsetController; },
/* harmony export */   "dm": function() { return /* binding */ startMainPageOrbAnimation; }
/* harmony export */ });
/* unused harmony exports Orb, ColorPalette */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1438);
/* harmony import */ var simplex_noise__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7048);
/* harmony import */ var debounce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(296);
/* harmony import */ var debounce__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(debounce__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pixi_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7118);
/* harmony import */ var hsl_to_hex__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6119);
/* harmony import */ var hsl_to_hex__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(hsl_to_hex__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _pixi_filter_kawase_blur__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8460);




// @ts-ignore


function random(min, max) {
    return Math.random() * (max - min) + min;
}
// map a number from 1 range to another
function map(n, start1, end1, start2, end2) {
    return (n - start1) / (end1 - start1) * (end2 - start2) + start2;
}
// Create a new simplex noise instance
var simplex = new simplex_noise__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP();
var Orb = /*#__PURE__*/ function() {
    "use strict";
    function Orb() {
        var fill = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : String(0x000000);
        var _this = this;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, Orb);
        // bounds = the area an orb is "allowed" to move within
        this.bounds = this.setBounds();
        // initialise the orb's { x, y } values to a random point within it's bounds
        this.x = random(this.bounds["x"].min, this.bounds["x"].max);
        this.y = random(this.bounds["y"].min, this.bounds["y"].max);
        // how large the orb is vs it's original radius (this will modulate over time)
        this.scale = 1;
        // what color is the orb?
        this.fill = fill;
        // the original radius of the orb, set relative to window height
        this.radius = random(window.innerHeight / 9, window.innerHeight / 5);
        // starting points in "time" for the noise/self similar random values
        this.xOff = random(0, 1000);
        this.yOff = random(0, 1000);
        // how quickly the noise/self similar random values step through time
        this.inc = 0.002;
        // PIXI.Graphics is used to draw 2d primitives (in this case a circle) to the canvas
        this.graphics = new pixi_js__WEBPACK_IMPORTED_MODULE_2__/* .Graphics */ .TCu();
        this.graphics.alpha = 0.825;
        // 250ms after the last window resize event, recalculate orb positions.
        window.addEventListener("resize", (0,debounce__WEBPACK_IMPORTED_MODULE_1__.debounce)(function() {
            _this.bounds = _this.setBounds();
        }, 250));
    }
    var _proto = Orb.prototype;
    _proto.setBounds = function setBounds() {
        // how far from the { x, y } origin can each orb move
        var maxDist = window.innerWidth < 1000 ? window.innerWidth / 3 : window.innerWidth / 5;
        // the { x, y } origin for each orb (the bottom right of the screen)
        var originX = window.innerWidth / 1.25;
        var originY = window.innerWidth < 1000 ? window.innerHeight / 3 : window.innerHeight / 5;
        // allow each orb to move x distance away from it's x / y origin
        return {
            x: {
                min: originX - maxDist,
                max: originX + maxDist
            },
            y: {
                min: originY - maxDist,
                max: originY + maxDist
            }
        };
    };
    _proto.update = function update() {
        // self similar "pseudo-random" or noise values at a given point in "time"
        var xNoise = simplex.noise2D(this.xOff, this.xOff);
        var yNoise = simplex.noise2D(this.yOff, this.yOff);
        var scaleNoise = simplex.noise2D(this.xOff, this.yOff);
        // map the xNoise/yNoise values (between -1 and 1) to a point within the orb's bounds
        this.x = map(xNoise, -1, 1, this.bounds["x"].min, this.bounds["x"].max);
        this.y = map(yNoise, -1, 1, this.bounds["y"].min, this.bounds["y"].max);
        // map scaleNoise (between -1 and 1) to a scale value somewhere between half of the orb's original size, and 100% of it's original size
        this.scale = map(scaleNoise, -1, 1, 0.5, 1);
        // step through "time"
        this.xOff += this.inc;
        this.yOff += this.inc;
    };
    _proto.render = function render() {
        // update the PIXI.Graphics position and scale values
        this.graphics.x = this.x;
        this.graphics.y = this.y;
        this.graphics.scale.set(this.scale);
        // clear anything currently drawn to graphics
        this.graphics.clear();
        // tell graphics to fill any shapes drawn after this with the orb's fill color
        this.graphics.beginFill(Number(this.fill));
        // draw a circle at { 0, 0 } with it's size set by this.radius
        this.graphics.drawCircle(0, 0, this.radius);
        // let graphics know we won't be filling in any more shapes
        this.graphics.endFill();
    };
    return Orb;
}();
var ColorPalette = /*#__PURE__*/ function() {
    "use strict";
    function ColorPalette() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, ColorPalette);
        this.hue = 0;
        this.complimentaryHue1 = 0;
        this.complimentaryHue2 = 0;
        this.saturation = 0;
        this.lightness = 0;
        this.baseColor = "";
        this.complimentaryColor1 = "";
        this.complimentaryColor2 = "";
        this.colorChoices = [];
        this.setColors();
        this.setCustomProperties();
    }
    var _proto = ColorPalette.prototype;
    _proto.setColors = function setColors() {
        // pick a random hue somewhere between 220 and 360
        this.hue = ~~random(220, 360);
        this.complimentaryHue1 = this.hue + 30;
        this.complimentaryHue2 = this.hue + 60;
        // define a fixed saturation and lightness
        this.saturation = 95;
        this.lightness = 50;
        // define a base color
        this.baseColor = hsl_to_hex__WEBPACK_IMPORTED_MODULE_3__(this.hue, this.saturation, this.lightness);
        // define a complimentary color, 30 degress away from the base
        this.complimentaryColor1 = hsl_to_hex__WEBPACK_IMPORTED_MODULE_3__(this.complimentaryHue1, this.saturation, this.lightness);
        // define a second complimentary color, 60 degrees away from the base
        this.complimentaryColor2 = hsl_to_hex__WEBPACK_IMPORTED_MODULE_3__(this.complimentaryHue2, this.saturation, this.lightness);
        // store the color choices in an array so that a random one can be picked later
        this.colorChoices = [
            this.baseColor,
            this.complimentaryColor1,
            this.complimentaryColor2
        ];
    };
    _proto.randomColor = function randomColor() {
        // pick a random color
        return this.colorChoices[~~random(0, this.colorChoices.length)].replace("#", "0x");
    };
    _proto.setCustomProperties = function setCustomProperties() {
        // set CSS custom properties so that the colors defined here can be used throughout the UI
        document.documentElement.style.setProperty("--hue", String(this.hue));
        document.documentElement.style.setProperty("--hue-complimentary1", String(this.complimentaryHue1));
        document.documentElement.style.setProperty("--hue-complimentary2", String(this.complimentaryHue2));
    };
    return ColorPalette;
}();
function startMainPageOrbAnimation() {
    var ref;
    var app = new pixi_js__WEBPACK_IMPORTED_MODULE_2__/* .Application */ .MxU({
        resizeTo: window,
        backgroundAlpha: 0
    });
    var colorPalette = new ColorPalette();
    app.stage.filters = [
        new _pixi_filter_kawase_blur__WEBPACK_IMPORTED_MODULE_4__/* .KawaseBlurFilter */ .p(30, 10, true)
    ];
    var orbs = [];
    for(var i = 0; i < 3; i++){
        //const orb = new Orb(colorPalette.randomColor());
        var orb = new Orb("0xAF82EE");
        app.stage.addChild(orb.graphics);
        orbs.push(orb);
    }
    app.ticker.add(function() {
        orbs.forEach(function(orb) {
            orb.update();
            orb.render();
        });
    });
    app.view.classList.add("orb-canvas");
    (ref = document.querySelector(".home")) === null || ref === void 0 ? void 0 : ref.appendChild(app.view);
}
var headerMenuOffsetController = function(headerEl, introH) {
    window.onscroll = function() {
        var scrollOffset = window.scrollY;
        if (scrollOffset >= introH) {
            headerEl.classList.add("fixed");
        } else {
            headerEl.classList.remove("fixed");
        }
    };
    var scrollOffset = window.scrollY;
    if (scrollOffset >= introH) {
        headerEl.classList.add("fixed");
    } else {
        headerEl.classList.remove("fixed");
    }
};


/***/ }),

/***/ 1520:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider_divider__WuPz1"};

/***/ })

}]);